<template>
  <div>
    <!-- <lu-form-item :label="uploadInfo.label" class="uploadItem" prop="itemName"> -->
    <lu-input
      disabled
      style="width: 300px"
      v-model="uploadValue"
      :placeholder="uploadInfo.placeholder"
    />
    <lu-button
      style="margin-right:5px;"
      type="primary"
      :loading="uploading"
      @click="uploadItem(uploadInfo.itemName)"
      >上传</lu-button
    >
    <lu-button type="error" @click="deleteItem(uploadInfo.itemName)"
      >删除</lu-button
    >
    <input
      @change="
        uploadItemFile(uploadInfo.itemName, uploadInfo.width, uploadInfo.height)
      "
      type="file"
      style="display: none"
      :ref="uploadInfo.itemName"
      :accept="uploadInfo.accept"
    />
    <div v-show="uploadValue" class="imgborder">
      <img :src="uploadValue" width="120px" height="auto" />
    </div>
    <!-- </lu-form-item> -->
  </div>
</template>

<script>
import { Notification } from "element-ui";

export default {
  name: "luUploadFile",
  data() {
    return {
      uploadValue: "",
      uploading: false
    };
  },
  props: {
    value: {
      type: String,
      default: function() {
        return "";
      }
    },
    uploadInfo: {
      type: Object,
      default: function() {
        return {
          accept: "image/*",
          label: "上传",
          placeholder: "请上传",
          itemName: "item",
          width: "",
          height: "",
          size: 500
        };
      }
    }
  },
  watch: {
    value: function(val) {
      this.uploadValue = val;
    }
  },
  methods: {
    uploadItem(item) {
      this.$refs[item].value = "";
      this.$refs[item].click();
    },
    deleteItem() {
      this.uploadValue = "";
    },
    uploadItemFile(item, width, height) {
      try {
        let files = this.$refs[item].files;
        if (
          this.uploadInfo.size &&
          files[0].size > this.uploadInfo.size * 1024
        ) {
          Notification.error({
            title: `请上传小于${this.uploadInfo.size}K 的内容！`
          });
        } else {
          if (this.uploadInfo.accept.includes("image")) {
            let fileImg = new FileReader();
            let imgRes = new Image();
            fileImg.readAsDataURL(files[0]);
            fileImg.onload = () => {
              imgRes.src = fileImg.result;
              imgRes.onload = () => {
                if (
                  width &&
                  height &&
                  (imgRes.width != width || imgRes.height != height)
                ) {
                  //有宽高判定而且判定失败
                  Notification.error({
                    title: `上传尺寸不符合，仅支持${width} * ${height}，请检查后重新上传`
                  });
                } else {
                  //不判断高宽或者判定通过
                  this.$emit("upload", files);
                }
              };
            };
          } else {
            this.$emit("upload", files);
          }
        }
      } catch (error) {
        // console.log(error);
        this.uploading = false;
        Notification.error({
          title: "出错了"
        });
      }
    }
    // async uploadFile(files) {
    //   this.uploading = true;

    //   let ossSetting = await oss.getOssSetting(files);
    //   let templateFile = await oss.uploadFile(
    //     ossSetting.file,
    //     ossSetting.key,
    //     ossSetting.oss
    //   );
    //   if (templateFile.res.statusCode == 200) {
    //     this.$set(
    //       this.uploadValue,
    //       templateFile.res.requestUrls[0].split("?")[0]
    //     );
    //     Notification.success({
    //       title: "上传成功"
    //     });
    //     this.uploading = false;
    //     this.$emit("upload-success", this.uploadValue);
    //   } else {
    //     Notification.error({
    //       title: "上传失败"
    //     });
    //     this.uploading = false;
    //   }
    // }
  }
};
</script>
<style lang="stylus">
.uploadItem{
  input.el-input__inner{
    border-bottom-right-radius: 0px;
    border-top-right-radius: 0px;
  }
  button.el-button--primary{
    border-bottom-left-radius: 0px;
    border-top-left-radius: 0px;
  }
}
</style>
